import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import ReactHtmlParser from 'react-html-parser';
import { withRouter } from 'react-router-dom';
import { Helmet } from 'react-helmet';

import Icon from 'style/fonts/glyphmaps/icon.component';
import ArticleActions from 'component/shared/article/actions.component';
import UserOwner from 'component/shared/article/userOwner.component';
import {
  findBySlug,
  fetchArticleComments,
  resetArticleComments,
  addArticleEvent,
  setArticleEvents,
} from 'store/action/articles.action';
import './article.details.component.style.css';
import ArticleCommentSection from './article.comment.section.component';
import articleImage from 'resource/img/article-default.jpg';

class ArticleDetails extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      article: {},
      comments: [],
    };
  }

  componentDidMount() {
    this._findBySlug();
  }

  _findBySlug() {
    const [, , slug] = this.props.location.pathname.split('/');
    return findBySlug(slug)
      .then(({ data }) => {
        this.setState(
          {
            article: data.article,
          },
          () => {
            this.props
              .resetArticleComments()
              .then(_ => this.props.fetchArticleComments(this.state.article.id))
              .then(_ => this.props.setArticleEvents(this.state.article));
          }
        );
      })
      .catch(e => {
        console.error(e);
        return this.setState({
          article: null,
        });
      });
  }

  render() {
    const ogUrl = this.props.location.pathname;
    const { article } = this.state;
    const {
      fetchArticleComments,
      comments,
      addArticleEvent,
      events,
    } = this.props;
    return (
      <>
        {!article ? (
          <div className="article-details">
            <section className="article-details-container text-center flex-column align-center justify-center">
              <h2>Artigo não encontrado</h2>
              <Icon
                size={35}
                fontFamily="MaterialIcons"
                name="sentiment-dissatisfied"
              />
              <button
                className="btn-rounded btn-primary"
                onClick={() => this.props.history.push('/')}
              >
                Voltar
              </button>
            </section>
          </div>
        ) : (
          <>
            <Helmet>
              <title>{article.title}</title>
              <meta name="description" content={article.summary} />

              <meta property="og:title" content={article.title} />
              <meta
                property="og:url"
                content={'https://juslabore.com.br' + ogUrl}
              />
              <meta property="og:description" content={article.summary} />

              <meta
                property="og:image"
                content={article.image ? article.image : articleImage}
              ></meta>

              <meta property="og:type" content="article" />
            </Helmet>
            <div className="article-details">
              <section className="article-details-container flex-column">
                <h1>{article.title}</h1>
                <img
                  src={article.image ? article.image : articleImage}
                  className="article-item-image"
                  alt="Imagem do artigo"
                />
                <h3>{article.summary}</h3>
                <div className="flex-row flex-1 justify-between m-1 article-details-actions">
                  <div className="w-40 flex-row justify-between">
                    <ArticleActions
                      like_count={events.like_count}
                      dislike_count={events.dislike_count}
                      comments={comments}
                      article={this.state.article}
                    />
                  </div>
                  <div className="flex-row justify-end">
                    <UserOwner
                      user={article.user_edited ? article.user_edited : {}}
                      created_at={article.created_at}
                    />
                  </div>
                </div>
                <div className="article-details-text">
                  {ReactHtmlParser(article.description)}
                </div>
              </section>
              <ArticleCommentSection
                addArticleEvent={addArticleEvent}
                comments={comments}
                fetchArticleComments={fetchArticleComments}
                article={article}
              />
            </div>
          </>
        )}
      </>
    );
  }
}
function mapStateToProps({ comments, articles, events }) {
  return {
    comments,
    articles,
    events,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    findBySlug: slug => dispatch(findBySlug(slug)),
    fetchArticleComments: id => dispatch(fetchArticleComments(id)),
    resetArticleComments: () => dispatch(resetArticleComments()),
    addArticleEvent: (id, type) => dispatch(addArticleEvent(id, type)),
    setArticleEvents: article => dispatch(setArticleEvents(article)),
  };
}
export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ArticleDetails)
);
